<kilowant-header title="Add Client"></kilowant-header>
<div class="backgroundImage">
  <div class="wrapperMain mainAccountDetailsMain accountDetails">
    <div class="form buyer">
      <section>
          <div class="card">
              <div class="table-view">
                  <div class="row">
                      <div class="cell">
                          <input type="text" name="FirstName" [class]="getClassesForInput('FirstName', true, clientInfo.firstName)" (input)="resetError('FirstName')" placeholder="First name" [(ngModel)]="clientInfo.firstName" [minlength]="validationService.getMinLength('User', 'firstName')" [maxlength]="validationService.getMaxLength('User', 'firstName')" />
                          @if (getVisibilityForLabel(clientInfo.firstName)) {
                          <div class="placeholder">First name</div>
                          }
                      </div>
                      <div class="cell">
                          <input type="text" name="LastName" [class]="getClassesForInput('LastName', true, clientInfo.lastName)" (input)="resetError('LastName')" placeholder="Last name" [(ngModel)]="clientInfo.lastName" [minlength]="validationService.getMinLength('User', 'lastName')" [maxlength]="validationService.getMaxLength('User', 'lastName')" />
                          @if (getVisibilityForLabel(clientInfo.lastName)) {
                          <div class="placeholder">Last name</div>
                          }
                      </div>
                  </div>
              </div>
              <input type="text" name="Company" [class]="getClassesForInput('Company', true, companyName)" (input)="resetError('Company')" placeholder="Company (optional)" [(ngModel)]="companyName" [minlength]="validationService.getMinLength('Company', 'name')" [maxlength]="validationService.getMaxLength('Company', 'name')" />
              @if (getVisibilityForLabel(companyName)) {
              <div class="placeholder">Company(optional)</div>
              }

              <input type="text"
                     name="addressLine1"
                     [class]="getClassesForInput('addressLine1', true, clientInfo.addressLine1)"
                     (input)="resetError('addressLine1')"
                     placeholder="Address Line"
                     [(ngModel)]="clientInfo.addressLine1"
                     [minlength]="validationService.getMinLength('User', 'address')"
                     [maxlength]="validationService.getMaxLength('User', 'address')" />
              @if (getVisibilityForLabel(clientInfo.addressLine1)) {
              <div class="placeholder">Address Line</div>
              }

              <div class="cols">
                  <div class="col">
                      <select [class]="getClassesForInput('stateId', true, 'ST')"
                              [compareWith]="compareFn"
                              name="stateId"
                              style="width: 60px !important;"
                              (change)="resetError('stateId'); filterCities();"
                              [(ngModel)]="clientInfo.state">
                          @if (clientInfo.state==null) {
                          <option [ngValue]="null" [disabled]="true">ST</option>
                          }
                          @for (state of states; track state) {
                          <option [ngValue]="state">{{state.stateCode}}</option>
                          }
                      </select>
                      @if (getVisibilityForLabel((clientInfo.state==null)?null:clientInfo.state.name)) {
                      <div class="placeholder">State</div>
                      }
                  </div>
                  <div class="col">
                      <select [class]="getClassesForInput('city', true, clientInfo.city)"
                              name="city"
                              (change)="resetError('city');"
                              [(ngModel)]="clientInfo.city">
                          @if (clientInfo.city==null) {
                          <option [ngValue]="null" [disabled]="true">City</option>
                          }
                          @for (city of cities; track city) {
                          <option [ngValue]="city">{{city}}</option>
                          }
                      </select>
                      @if (getVisibilityForLabel(clientInfo.city)) {
                      <div class="placeholder">City</div>
                      }
                  </div>
                  <div class="col">
                      <input type="text"
                             name="address"
                             [class]="getClassesForInput('zip', true, clientInfo.zip)"
                             style="min-width: 80px"
                             (input)="resetError('zip')"
                             placeholder="Zip"
                             [(ngModel)]="clientInfo.zip"
                             [minlength]="validationService.getMinLength('User', 'zip')"
                             [maxlength]="validationService.getMaxLength('User', 'zip')" />
                      @if (getVisibilityForLabel(clientInfo.zip)) {
                      <div class="placeholder">Zip</div>
                      }
                  </div>
              </div>

              <input type="text" name="Phone"
                     [class]="getClassesForInput('Phone', true, (((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'1':'')))"
                     (input)="resetError('Phone')"
                     placeholder="Mobile Phone"
                     [dropSpecialCharacters]="false"
                     [formControl]="currentPhoneNumber"
                     (focus)="focusField('Phone')"
                     mask="(000) 000-0000"
                     [showMaskTyped]="(focusedField()=='Phone')||(currentPhoneNumber.value!=null && currentPhoneNumber.value?.trim()!='' && !currentPhoneNumber.value.valid)" />
              @if (getVisibilityForLabel(((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'phone':''))) {
              <div class="placeholder">Mobile Phone</div>
              }

              <input type="text"
                     name="Email"
                     [class]="getClassesForInput('Email', true, clientInfo.email)"
                     (input)="resetError('Email')"
                     placeholder="Email"
                     [(ngModel)]="clientInfo.email"
                     [minlength]="0"
                     [maxlength]="validationService.getMaxLength('User', 'email')" />
              @if (getVisibilityForLabel(clientInfo.email)) {
              <div class="placeholder">Email</div>
              }
              <label><input type="checkbox" name="active" [(ngModel)]="clientInfo.isActive" [checked]="clientInfo.isActive" /> Active</label>

              @if (companyName!=null) {
              <div>
                  <div class="mb-10 mt-10">
                      <label>
                          <input type="checkbox" name="taxExempt" [(ngModel)]="taxExempt" /> Is your business
                          tax exempt?
                      </label>
                  </div>
                  @if (taxExempt) {
                  <div>
                      <input type="text" name="FederalTaxID" class="w-100"
                             [class]="getClassesForInput('FederalTaxID', true, federalTaxID)" value=""
                             (input)="resetError('FederalTaxID')" [(ngModel)]="federalTaxID"
                             placeholder="Federal Tax ID" />
                      @if (getVisibilityForLabel(federalTaxID)) {
                      <div class="placeholder">Federal Tax ID</div>
                      }
                      <div class="mt-20"> Please upload a photo or a copy of your tax exempt certificate.</div>
                      @if ((fileToUpload==null) && taxExemptCertificateDocument==null) {
                      <label class="formLabel"
                             [class]="(errorY().isWrong('fileToUpload'))?'error':''">
                          CHOOSE FILES
                          <span>no files selected</span>
                          <input type="file" name="taxExemptCertificateDocument" class="required" value=""
                                 placeholder="Tax Exempt Certificate Document" (change)="handleFileInput($event)" />
                      </label>
                      }
                      @if (fileToUpload!=null || taxExemptCertificateDocument!=null) {
                      <div class="files-list">
                          <span>File selected</span>
                          <ul>
                              @if (taxExemptCertificateDocument!=null) {
                              <li>
                                  <a (click)="deleteExistingFile(taxExemptCertificateDocument.key)"></a>
                                  <div class="link" (click)="downloadFile(true, taxExemptCertificateDocument.key)">{{taxExemptCertificateDocument.value}}</div>
                              </li>
                              }
                              @if (fileToUpload!=null) {
                              <li>
                                  <a (click)="deleteFile()"></a>
                                  <div class="link" (click)="downloadFile(false, null)">{{fileToUpload.name}}</div>
                              </li>
                              }
                          </ul>
                      </div>
                      }
                  </div>
                  }
              </div>
              }

              @if (errorY().showError()) {
              <div class="error-block">{{errorY().error}}</div>
              }
          </div>
              </section>

              <div class="block-buttons full-width mb-20 under-card">
                <button type="button" (click)="goBack()">Back</button>
                <button appOneClick type="button" class="highlighted-button" (oneClick)="confirm()">Confirm</button>
              </div>
            </div>
          </div>
        </div>